<template>
  <div>
    <Dialog_EditGroup></Dialog_EditGroup>
    <FriendGroup :mode="mode" v-on:setChoiseGroup="setChoiseGroup"></FriendGroup>
  </div>
</template>

<script>
import FriendGroup from "../components/Main/FriendGroup.vue";
import Dialog_EditGroup from "@/components/Main/Dialog_EditGroup.vue";
import store from "../vuex/store_friendList.js";
import { FriendListHandler } from "../handler/FriendListHandler";
import { MobileHomeHandler } from "@/handler/MobileHomeHandler.js";
import { SignalrConnectionHandler } from "@/handler/SignalrConnectionHandler.js";

export default {
  components: {
    FriendGroup,
    Dialog_EditGroup
  },
  data() {
    return {
      group: [],
      mode: {
        type: "Mobile",
        token: "",
        staff: []
      }
    };
  },
  created() {
    document.title = "好友群組";
    var TutorChatTokenModel = MobileHomeHandler.GetTutorChatTokenModel(
      this.$route.query.tct
    );
    this.mode.staff = {
      userid: TutorChatTokenModel.Account,
      staffsn: TutorChatTokenModel.StaffSn,
      staffid: TutorChatTokenModel.StaffId
    };
    this.mode.token = this.$route.query.tct;
    this.iniSignalr();
  },
  // 元件銷毀時一定要停掉連線。SignalrConnectionHandler 會無限退避重連，
  // 沒停的話 SPA route 切換後會留下永遠重連的殭屍連線，而且每次重連都會再
  // 跑一次 onConnected（AddGroup / GetDataByToken），觸發 server 端的單一
  // 登入檢查去 closepage 掉當前活著的那條連線。
  beforeDestroy() {
    if (this.signalrconn && typeof this.signalrconn.stop === "function") {
      this.signalrconn.stop();
    }
  },
  methods: {
    iniSignalr: function() {
      //這裡一定要把mode裡面的staffid裝起來用，滿怪的，可能是型態問題。
      var staffid = this.mode.staff.staffid;
      this.signalrconn = SignalrConnectionHandler.Create({
        url: this.$conf.MessageAPI + "/signalr",
        hub: "mainfriendListHub",
        // 重連後 server 端 group 成員資格不會保留，必須重新 AddGroup
        onConnected: function(proxy) {
          proxy.invoke("AddGroup", staffid);
        }
      });
      var proxy = this.signalrconn.proxy;
      this.signalrconn.start();

      //更新全部好友未讀數
      proxy.on("refreshGroupUnreadCount", notify => {
        store.dispatch("refreshGroupUnreadCount", notify);
      });

      //關閉頁面
      proxy.on("closepage", data => {
        this.signalrconn.stop();
        window.open("", "_self", "");
        window.close();
      });
    },
    setChoiseGroup: function(group) {
      this.group = group;
      //為了解決手機板從好友列表進入聊天室Vuex會遺失的問題，將值新增到sessionStorage。
      window.sessionStorage.setItem("groupId", group.Id);
      window.sessionStorage.setItem("GroupSysType", group.GroupSysType);

      window.location.href =
        "#/MobileFriendListView?tct=" + this.$route.query.tct;
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileFriendGroupView.vue